import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

export default function DonorInvalidTable({
  errorRows,
  setOpenEditDonor,
  deleteRow
}) {
  const columns = [
    {
      text: "No",
      formatter: (_, __, indexRow) => {
        return <span>{indexRow + 1}</span>;
      }
    },
    {
      dataField: "data.type",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Tipe Donatur",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.name",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Nama",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.greeting",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Sapaan",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.hp",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "HP",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.email",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Email",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.address",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Alamat",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.province",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Provinsi",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.city",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Kota",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.district",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Kecamatan",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.postal_code",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Kode Pos",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.nik",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "NIK",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.npwp",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "NPWP",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.npwz",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "NPWZ",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.is_alive",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Status Hidup",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.is_active",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Status Aktif",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.kode_rekening",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Kode Rekening",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.tanggal_lahir",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Tanggal Lahir",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.jenis_kelamin",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Jenis Kelamin",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.pekerjaan",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Pekerjaan",
      style: { cursor: "pointer" }
    },
    {
      dataField: "data.pendidikan",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Pendidikan Terakhir",
      style: { cursor: "pointer" }
    },
    {
      formatter: (cell, row) => {
        return (
          <>
            <OverlayTrigger
              overlay={
                <Tooltip id="products-delete-tooltip">Hapus donatur</Tooltip>
              }
            >
              <a
                className="btn btn-icon btn-light btn-hover-danger btn-sm"
                style={{ zIndex: "100" }}
                onClick={e => {
                  e.stopPropagation();
                  deleteRow(row);
                }}
              >
                <span className="svg-icon svg-icon-md svg-icon-danger">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                  />
                </span>
              </a>
            </OverlayTrigger>
          </>
        );
      }
    }
  ];

  const tableRowEvents = {
    onClick: (e, row, rowIndex) => {
      console.log(`e`, e);
      setOpenEditDonor(prev => ({
        ...prev,
        show: true,
        initValues: row
      }));
    }
  };

  return (
    <>
      <BootstrapTable
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        rowEvents={tableRowEvents}
        bootstrap4
        bordered={true}
        remote
        keyField="uuid"
        data={errorRows}
        columns={columns}
      />
    </>
  );
}
